<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Lista de Créditos Concessionárias</h2>
    </div>

    <tds-accordion>
        <!-- Filtros -->
        <tds-accordion-item header="Filtros" aria-level="6" expanded>
            <div class="tds-row">
                <tds-dropdown name="dropdown" label-position="outside" placeholder="Front-Office" size="lg" animation="slide" open-direction="auto" tds-aria-label="A dropdown component" style="padding-right: 45px; width: 10.8%">
                    <tds-dropdown-option value="option-1">Rafael Nunes</tds-dropdown-option>
                    <tds-dropdown-option value="option-2">Derick de Oliveira</tds-dropdown-option>
                </tds-dropdown>
                <tds-dropdown name="dropdown" label-position="outside" placeholder="Banco" size="lg" animation="slide" open-direction="auto" tds-aria-label="A dropdown component" style="padding-right: 45px; width: 10.8%">
                    <tds-dropdown-option value="option-1">Outros</tds-dropdown-option>
                    <tds-dropdown-option value="option-2">Scania Banco</tds-dropdown-option>
                </tds-dropdown>
                <tds-text-field type="date" helper="Início Previsão" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Início Previsão" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-text-field type="date" helper="Final Previsão" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Final Previsão" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-text-field type="date" helper="Início Lançamento" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Início Lançamento" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-text-field type="date" helper="Final Lançamento" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Final Lançamento" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-text-field type="text" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Solicitação" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;"></tds-text-field>
                <tds-dropdown name="dropdown" label-position="outside" placeholder="Estágios Neg" size="lg" animation="slide" open-direction="auto" tds-aria-label="A dropdown component" style="padding-right: 45px; width: 10.8%">
                    <tds-dropdown-option value="option-1">Confirmação</tds-dropdown-option>
                    <tds-dropdown-option value="option-2">Prog Solicitada</tds-dropdown-option>
                </tds-dropdown>
            </div>

            <div class="tds-row" style="padding-top: 20px; justify-content: center">
                <tds-button type="button" variant="primary" size="lg" text="Pesquisar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
                <tds-button type="button" variant="secondary" size="lg" text="Limpar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
            </div>
        </tds-accordion-item>

        <!-- Tabela -->
         <tds-accordion-item header="Tabela" aria-level="6" expanded>
            <div class="tds-row">
                <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
                    <tds-table-toolbar>
                        <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1" style="margin-left: 8px;">
                            <tds-button variant="secondary" size="sm" title="Exportar para Arquivo">
                                <tds-icon slot="icon" size="18px" name="document_xls"></tds-icon>
                            </tds-button>
                        </div>
                    </tds-table-toolbar>
                    <tds-table-header>
                        <tds-header-cell cell-key="actions"></tds-header-cell>
                        <tds-header-cell cell-key="edit"></tds-header-cell>
                        <tds-header-cell cell-key='solic' cell-value='Solicitação' sortable></tds-header-cell>
                        <tds-header-cell cell-key='cnpj' cell-value='CNPJ' sortable></tds-header-cell>
                        <tds-header-cell cell-key='razaoSocial' cell-value='Razão Social' sortable></tds-header-cell>
                        <tds-header-cell cell-key='valor' cell-value='Valor' sortable></tds-header-cell>
                        <tds-header-cell cell-key='dealer' cell-value='Dealer' sortable></tds-header-cell>
                        <tds-header-cell cell-key='fOffice' cell-value='F-Office' sortable></tds-header-cell>
                        <tds-header-cell cell-key='negRef' cell-value='Neg.Ref' sortable></tds-header-cell>
                        <tds-header-cell cell-key='estagio' cell-value='Estágio' sortable></tds-header-cell>
                        <tds-header-cell cell-key='modelo' cell-value='Modelo' sortable></tds-header-cell>
                        <tds-header-cell cell-key='banco' cell-value='Banco' sortable></tds-header-cell>
                        <tds-header-cell cell-key='sitCred' cell-value='Sit.Créd.' sortable></tds-header-cell>
                        <tds-header-cell cell-key='qtd' cell-value='Qtd' sortable></tds-header-cell>
                        <tds-header-cell cell-key='previsao' cell-value='Previsão' sortable></tds-header-cell>
                        <tds-header-cell cell-key='aprovar' cell-value='Aprovar' sortable></tds-header-cell>
                        <tds-header-cell cell-key='comentarios' cell-value='' sortable></tds-header-cell>
                        <tds-header-cell cell-key='btnSalvar' cell-value='' sortable></tds-header-cell>
                    </tds-table-header>
                    <tds-table-body>
                        <tds-table-body-row>
                            <tds-body-cell cell-key="actions">
                                <div class="action-buttons" title="Observações">
                                    <tds-icon id="edit" name="info" size="25px" style="cursor: pointer;" ></tds-icon>
                                </div>
                            </tds-body-cell>
                            <tds-body-cell cell-key="edit">
                                <div class="action-buttons" title="Editar Observações">
                                    <tds-icon id="edit" name="edit" size="25px" style="cursor: pointer;" ></tds-icon>
                                </div>
                            </tds-body-cell>
                            <tds-body-cell cell-key="solic">765527</tds-body-cell>
                            <tds-body-cell cell-key="cnpj">10.292.914/0001-27</tds-body-cell>
                            <tds-body-cell cell-key="razaoSocial">AUTO POSTO SANTOS DUMONT LTDA</tds-body-cell>
                            <tds-body-cell cell-key="valor">565.899,00</tds-body-cell>
                            <tds-body-cell cell-key="dealer">SUPERMAC MANAUS (245)</tds-body-cell>
                            <tds-body-cell cell-key="fOffice">SSBJAK</tds-body-cell>
                            <tds-body-cell cell-key="negRef">21/96</tds-body-cell>
                            <tds-body-cell cell-key="estagio">PROG SOLICITADA</tds-body-cell>
                            <tds-body-cell cell-key="modelo">R 540 A6X4 E5</tds-body-cell>
                            <tds-body-cell cell-key="banco">Santander</tds-body-cell>
                            <tds-body-cell cell-key="sitCred">Em Análise</tds-body-cell>
                            <tds-body-cell cell-key="qtd">1</tds-body-cell>
                            <tds-body-cell cell-key="previsao">03/06/2022</tds-body-cell>
                            <tds-body-cell cell-key="aprovar">
                                <tds-radio-button name=”my-radio-button” value=”radio-value”> 
                                </tds-radio-button> Yes
                                <tds-radio-button name=”my-radio-button” value=”radio-value”> 
                                </tds-radio-button> No
                            </tds-body-cell>
                            <tds-body-cell cell-key="comentarios">
                                <tds-datetime 
                                    type="date" 
                                    label="Created at" 
                                    default-value="" 
                                    min="" 
                                ></tds-datetime> 
                            </tds-body-cell>
                            <tds-body-cell cell-key="btnSalvar">
                                <tds-button
                                    type="button"
                                    variant="primary"
                                    size="lg"
                                    text="Salvar"
                                    animation="none"
                                    tds-aria-label="undefined"
                                    name=""
                                    value=""
                                ></tds-button>
                            </tds-body-cell>
                        </tds-table-body-row>
                    </tds-table-body>
                </tds-table>
            </div>
         </tds-accordion-item>
    </tds-accordion>
</div>